import { TSectionType } from '../../../types/sectionType';
import { useApplicationContext } from '../../../utils/applicationContext';

const DEFAULT_IMAGE_ANIMATION_SECTIONS = ['index', 'commercial', 'sale', 'rent', 'new-buildings'];

export function useDefaultImageAnimationEnabled(section: TSectionType): boolean {
  const { config } = useApplicationContext();

  const defaultImageAnimationSections =
    config.get<TSectionType[]>('frontend-mainpage.defaultImageAnimationSections') ?? DEFAULT_IMAGE_ANIMATION_SECTIONS;

  return defaultImageAnimationSections.includes(section);
}
